export default __webpack_public_path__ + "static/media/flutterwave.f2cd7bc1.png";